import AssetIndexView from './view/AssetIndexView'
import AssetFilters from './components/filters/AssetFilters'
import CollectionsTable from './components/table/CollectionsTable'
import {
  TYPE_STATUS_ASSET_ACTIVITIES,
  LABEL_TO_STATUS_VALUE,
  FILTER_KEYS
} from './constants/assetCollectionsStatus'

const processAssetCollectionsForFilter = (filtersfetch, { TYPE_STATUS, LABEL_TO_STATUS_VALUE, FILTER_KEYS }) => {
  let mapping = {}
  const userOptions = (filtersfetch.user_asset_collections || []).map(u => {
    const label = `${u.user_uid} - ${u.user_full_name}`
    mapping[label] = u.user_uid
    return label
  })
  TYPE_STATUS.forEach(label => { mapping[label] = LABEL_TO_STATUS_VALUE[label] })

  return {
    filters: [
      { key: FILTER_KEYS.USER, value: userOptions },
      { key: FILTER_KEYS.STATUS, value: TYPE_STATUS }
    ],
    mapping
  }
}

export default function CollectionsIndexView() {
  return (
    <AssetIndexView
      title="Cierre de activos"
      endpoint="asset_collections"
      FiltersComponent={AssetFilters}
      TableComponent={CollectionsTable}
      showModelPath="/cierre_activos/"
      navActiveItem="cierre_activos"
      processFiltersFn={processAssetCollectionsForFilter}
      statusConstants={{
        TYPE_STATUS: TYPE_STATUS_ASSET_ACTIVITIES,
        LABEL_TO_STATUS_VALUE,
        FILTER_KEYS
      }}
      searchPlaceholder="Buscar por # de documento o usuario" 
    />
  )
}
